
import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import Spinner from "../spinner/Spinner";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link } from "react-router-dom";
import formatDate from "../../components/utils/DateFormatter";

const ClusterLocationDetails = () => {
    const [clusterDetails, setClusterDetails] = useState("");
    const [loading, setLoading] = useState(true);
    const location = useLocation();


    const clusterLocation = location.state?.clusterLocation;

    useEffect(() => {
        if (clusterLocation) {
            // console.log("cluster data is here", clusterLocation);
            setClusterDetails(clusterLocation);
        }

    }, [clusterLocation]);

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Cluster Point
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Details</p>
                                </li>
                            </ol>
                        </nav>

                    </section>
                    <div className="flex justify-end">
                        <Link
                            to="/admin/cluster/location"
                            className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        >
                            <span className="flex justify-center sm:justify-start mx-2">
                                Go Back
                            </span>
                        </Link>
                    </div>

                    {/* {loading ? (
                        <Spinner loading={loading} />
                    ) : ( */}
                    <div className="p-2 w-full mt-4">
                        <h1 className="text-dash md:text-lg">Cluster Point Details</h1>

                        {clusterDetails ? (

                            <div className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                <div className="px-6 py-4 border border-darkGreen3">
                                    <span>Address:</span>  {clusterDetails.address || "NOT AVAILABLE"}
                                </div>
                                <div className="px-6 py-4 border border-darkGreen3">
                                    <span>Created Date:</span>  {clusterDetails.created_at ? formatDate(clusterDetails.created_at) : "NOT AVAILABLE"}


                                </div>
                            </div>

                        ) : (
                            <div>
                                <div colSpan="3" className="px-6 py-4 text-center">
                                    No items available.
                                </div>
                            </div>
                        )}
                    </div>
                    {/* // )} */}
                </div>
            </MainLayouts>
        </div>
    );
};

export default ClusterLocationDetails;

